import React, { Component } from 'react';
import warningIcon from '../../../assets/icons/warning.png';
import './styles.sass';

interface ValidationModalProps {
  render: boolean;
  onClose: () => void;
  title?: string;
  message: string;
  missingFields: string[];
  onCompleteProfile?: () => void;
  helpText?: string;
}

export default class ValidationModal extends Component<ValidationModalProps> {
  render() {
    if (!this.props.render) return null;

    return (
      <div className="validation-modal-overlay">
        <div className="validation-modal">
          <div className="modal-header">
            <img src={warningIcon} alt="warning" className="warning-icon" />
            <h3>{this.props.title || 'Perfil Incompleto'}</h3>
          </div>
          
          <div className="modal-body">
            <p className="main-message">{this.props.message}</p>
            
            {this.props.missingFields && this.props.missingFields.length > 0 && (
              <div className="missing-fields-section">
                <h4>Campos obrigatórios faltantes:</h4>
                <ul className="missing-fields-list">
                  {this.props.missingFields.map((field, index) => (
                    <li key={index} className="missing-field-item">
                      <span className="field-bullet">•</span>
                      <span className="field-text">{field}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            
            <div className="help-text">
              <p>{this.props.helpText || 'Para baixar seu currículo, complete essas informações no seu perfil.'}</p>
            </div>
          </div>
          
          <div className="modal-footer">
            <button 
              className="cancel-btn" 
              onClick={this.props.onClose}
            >
              Fechar
            </button>
            {this.props.onCompleteProfile && (
              <button 
                className="primary-btn" 
                onClick={this.props.onCompleteProfile}
              >
                Completar Perfil
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}
